module.exports = __webpack_public_path__ + "static/media/Priyanka_Bed_CV.84f5e362.pdf";